// extracted by mini-css-extract-plugin
export default {"statisticCard":"StatisticCard_statisticCard__knINM","data":"StatisticCard_data__sk2pu","image":"StatisticCard_image__1kcHG"};